import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import SiteFooter from "../components/SiteFooter";
import BrandLogo from "../components/BrandLogo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (!u.onboarded) {
        if (u.account_type === "brand") navigate("/onboarding/brand");
        else if (u.account_type === "agent" || u.account_type === "club") navigate("/onboarding/agency");
        else navigate("/onboarding");
      } else if (u.account_type === "brand") {
        navigate("/app/brand");
      } else {
        navigate("/app/dashboard");
      }
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <div className="px-6 md:px-12 py-6 border-b border-line">
        <Link to="/" className="flex items-center w-fit">
          <BrandLogo variant="wordmark" size={28} showLink={false} />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="label-eyebrow mb-3">Sign in</div>
          <h1 className="font-heading text-4xl uppercase tracking-tight mb-8">Welcome back.</h1>
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="label-eyebrow block mb-2">Email</label>
              <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email-input"
                className="w-full bg-bg border border-line focus:border-volt outline-none px-4 py-3 text-white" />
            </div>
            <div>
              <div className="flex justify-between items-baseline mb-2">
                <label className="label-eyebrow">Password</label>
                <Link to="/forgot-password" className="text-[10px] uppercase tracking-widest text-ink-muted hover:text-volt transition-colors" data-testid="login-forgot-password-link">
                  Forgot?
                </Link>
              </div>
              <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="login-password-input"
                className="w-full bg-bg border border-line focus:border-volt outline-none px-4 py-3 text-white" />
            </div>
            {error && <div className="text-sm text-[#FF3B30] border border-[#FF3B30]/30 p-3" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="w-full btn-volt" data-testid="login-submit-btn">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-6 text-sm text-ink-muted">
            No account? <Link to="/register" className="text-volt uppercase tracking-widest text-xs" data-testid="login-to-register-link">Create one</Link>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
